import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/error.tsx");
